
import {Person, PersonOutline, Settings, SettingsOutlined, ViewCarouselOutlined, ViewCarousel, NotificationsNone, Notifications } from '@material-ui/icons'
import {RiBook3Fill, RiBook3Line} from 'react-icons/ri'
const tabs = [
    {
        name: 'Profile',
        panel: 0,
        icon: <PersonOutline />,
        activeIcon: <Person />
    },
    {
        name: 'AdCard',
        panel: 2,
        icon: <ViewCarouselOutlined />,
        activeIcon: <ViewCarousel />
    },
    // {
    //     name: 'Notifications',
    //     panel: 4,
    //     icon: <NotificationsNone />,
    //     activeIcon: <Notifications />

    // },
    // {
    //     name: 'Settings',
    //     panel: 3,
    //     icon: <SettingsOutlined />,
    //     activeIcon: <Settings />
    // }
]

export default tabs